<template>
  <div class="all">
    <div class="headers">
      <div class=""></div>
      <div v-for="workshift in workshifts" :key="workshift.id">
        <div class="">{{ workshift.name }}</div>
      </div>
    </div>
    <div class="adherence-values">
      <div class="">{{ $t("outOfSpecificationTableAdherence") }}</div>
      <div v-for="workshift in workshifts" :key="workshift.id">
        <div class="">
          {{ workshift.aderencia == -9999 ? "-" : workshift.aderencia + " %" }}
        </div>
      </div>
    </div>
    <div class="treated-occurrence-values">
      <div class="">{{ $t("oc-tratadas") }}</div>
      <div v-for="workshift in workshifts" :key="workshift.id">
        <div class="">
          {{ workshift.ocorrencia == -9999 ? "-" : workshift.ocorrencia + " %" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mediator from "../utilites/Mediator";
import { urlMainAPI } from "@/global";
import axios from "axios";

export default {
  data() {
    return {
      workshiftHeader01: "",
      workshiftHeader02: "",
      workshiftHeader03: "",
      workshifts: [],
      adherences: [],
      occurences: [],
    };
  },

  mounted() {
    Mediator.notify(this, "init-footer-pgdi");
  },

  methods: {
    async loadHeadersOfFooter() {
      const url = `${urlMainAPI}/getlistworkshiftandarea`;
      await axios
        .get(url)
        .then((res) => {
          this.workshiftHeader01 = res.data.workshift[1];
          this.workshiftHeader02 = res.data.workshift[2];
          this.workshiftHeader03 = res.data.workshift[3];
        })
        .catch((e) => {
          console.log(e);
        });
    },

    loadAdherencesAndOcurrences(data) {
      let workshiftsKeys = Object.keys(data.workshifAdherence);
      workshiftsKeys.forEach((element) => {
        this.adherences.push(data.workshifAdherence[element]);
      });

      let occurencesKeys = Object.keys(data.percentOcurrenceTreatedWorkshift);
      occurencesKeys.forEach((element) => {
        this.occurences.push(data.percentOcurrenceTreatedWorkshift[element]);
      });

      const validOccurrences = this.occurences.filter(value => value !== -9999);
      const meanOccurrence = validOccurrences.length > 0
        ? (validOccurrences.reduce((sum, value) => sum + value, 0) / validOccurrences.length).toFixed(2)
        : '0.00';  
      this.adherences.push(data.adherenceGeneral.toFixed(2));
      this.occurences.push(meanOccurrence); //
    },

    async loadInfos(data) {
      await this.loadHeadersOfFooter();

      this.adherences = [];
      this.occurences = [];
      this.loadAdherencesAndOcurrences(data);

      let itemWorkShift01 = {
        id: 1,
        name: this.workshiftHeader01,
        aderencia: this.adherences[0],
        ocorrencia: this.occurences[0],
      };
      let itemWorkShift02 = {
        id: 2,
        name: this.workshiftHeader02,
        aderencia: this.adherences[1],
        ocorrencia: this.occurences[1],
      };
      let itemWorkShift03 = {
        id: 3,
        name: this.workshiftHeader03,
        aderencia: this.adherences[2],
        ocorrencia: this.occurences[2],
      };
      let itemWorkShift04 = {
        id: 4,
        name: this.$t("geralAdherence"),
        aderencia: this.adherences[3],
        ocorrencia: this.occurences[3],
      };
      this.workshifts = [
        itemWorkShift01,
        itemWorkShift02,
        itemWorkShift03,
        itemWorkShift04,
      ];
    },
  },
};
</script>

<style scoped>
.all {
  display: grid;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5rem;
  right: calc(50% - 250px);
}

.headers {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  font-size: 15px;
  font-weight: 500;
  justify-items: center;
}

.adherence-values {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  font-size: 15px;
  font-weight: 500;
  justify-items: center;
}

.treated-occurrence-values {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  font-size: 15px;
  font-weight: 500;
  justify-items: center;
  bottom: 0;
}

@media only screen and (max-height: 728px) {
  .all {
    width: 500;
    top: 57vh;
  }

  .headers,
  .adherence-values,
  .treated-occurrence-values {
    font-size: 13px;
  }
}
</style>
